module.exports = __webpack_public_path__ + "img/patient_m.ff35ce95.png";